export const inputDescriptionStyles = {
  flexShrink: 0,
  paddingLeft: '8px',
};
